import React from 'react';
const DEFAULT_JSME_ID = 'jsme_default';
const PATH_TO_JSME = 'jsme/';

declare const window: any;
window.jsmeApplets = {};

interface CallBack {
  name: string;
  func: (event: any) => void;
}

interface JsmeProps {
  jsmeId?: string;
  width?: string;
  height?: string;
  options?: object;
  molFile: string;
  callbacks: CallBack[];
  shouldJSMEUpdate: boolean;
}

export default class Jsme extends React.Component<JsmeProps> {
  instance?: HTMLDivElement;
  jsmeContainer?: string;
  jsmeCheckInterval?: NodeJS.Timeout;
  static defaultProps: JsmeProps = {
    jsmeId: DEFAULT_JSME_ID,
    width: '380px',
    height: '340px',
    options: {},
    molFile: '',
    callbacks: [],
    shouldJSMEUpdate: false,
  };

  constructor(props: Readonly<JsmeProps>) {
    super(props);
    this.jsmeContainer = `jsme_container_${this.props.jsmeId}`;
  }

  componentDidMount() {
    const { JSApplet } = window;
    if (!JSApplet) {
      // Mount to root if possible
      const mountPoint = document.getElementById('root') || this.instance!;
      const jsmeLib = document.createElement('script');
      jsmeLib.type = 'text/javascript';
      jsmeLib.async = true;
      jsmeLib.lang = 'javascript';
      jsmeLib.src = `${PATH_TO_JSME}jsme.nocache.js`;
      mountPoint.appendChild(jsmeLib);

      // We need this to suppress warning of JSME lib that expects jsmeOnLoad function
      const jsmeOnLoad = document.createElement('script');
      jsmeOnLoad.type = 'text/javascript';
      jsmeOnLoad.async = true;
      jsmeOnLoad.lang = 'javascript';
      jsmeOnLoad.innerHTML = 'function jsmeOnLoad() {};';
      mountPoint.appendChild(jsmeOnLoad);

      // Create applet instance when JSApplet is available (instead of jsmeOnLoad)
      this.jsmeCheckInterval = setInterval(() => {
        console.log('Waiting for JSME...');
        this.addJSMEApplet();
      }, 50);
    } else {
      this.addJSMEApplet();
    }
  }

  addJSMEApplet = () => {
    const { JSApplet } = window;
    if (JSApplet) {
      if (this.jsmeCheckInterval) {
        clearInterval(this.jsmeCheckInterval);
        this.jsmeCheckInterval = undefined;
      }
      window.jsmeApplets[this.props.jsmeId as any] = new JSApplet.JSME(
        this.jsmeContainer,
        this.props.width,
        this.props.height,
        { ...this.props.options, mol: this.props.molFile },
      );
      this.props.callbacks.forEach((callback: CallBack) => {
        window.jsmeApplets[this.props.jsmeId as any].setCallBack(callback.name, callback.func);
      });
    }
  };

  componentDidUpdate(prevProps: Readonly<JsmeProps>) {
    // Update JSME when molFile prop changes without the jsme having unmounted
    // E.g. history selection
    const interval = setInterval(() => {
      const { JSApplet } = window;
      if (JSApplet && prevProps.molFile !== this.props.molFile) {
        clearInterval(interval);
        window.jsmeApplets[this.props.jsmeId as any].readMolFile(this.props.molFile);
      }
    }, 250);
  }

  shouldComponentUpdate({ shouldJSMEUpdate }: JsmeProps): boolean {
    return shouldJSMEUpdate;
    // return true;
  }

  render() {
    return (
      <>
        <div ref={el => (this.instance = el!)} />
        <div id={this.jsmeContainer} />
      </>
    );
  }
}

export const smiles = (jsmeId: string = DEFAULT_JSME_ID) => {
  return window.jsmeApplets[jsmeId].smiles();
};

export const molFile = (jsmeId: string = DEFAULT_JSME_ID) => {
  return window.jsmeApplets[jsmeId].molFile();
};

export const setMolFile = (molFile: string, jsmeId: string = DEFAULT_JSME_ID) => {
  window.jsmeApplets[jsmeId] && window.jsmeApplets[jsmeId].readMolFile(molFile);
};
